// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login'
import Header from './pages/Header';
import Footer from './pages/Footer';
import WomensHealth from './pages/WomensHealth';
import CarePackages from './pages/CarePackages';
import Services from './pages/Services';
import PreconceptionCare from './pages/care-packages/PreconceptionCare';
import AntenatalCare from './pages/care-packages/AntenatalCare';
import LabourCare from './pages/care-packages/LabourCare';
import PostnatalCare from './pages/care-packages/PostnatalCare';
import AdolescentCare from './pages/care-packages/AdolescentCare';
import ChildCare from './pages/care-packages/ChildCare';
import ScheduleConsultation from './pages/ScheduleConsultation';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';

import PrivateRoute from './protected/PrivateRoute';
import AppointmentForm from './protected/AppointmentForm';
import ChildVaccinationForm from './protected/ChildVaccinationForm';
import LaborProgressForm from './protected/LaborProgressForm';
import MedicalRecordForm from './protected/MedicalRecordForm';
import PatientRegistration from './protected/PatientRegistration';
import PostnatalVisitForm from './protected/PostnatalVisitForm';
import PregnancyDetailsForm from './protected/PregnancyDetailsForm';
import StaffRegistration from './protected/StaffRegistration';

import Dashboard from './protected/Dashboard';
import MessagesPage from './protected/dashboard-components/MessagesPage';
import FormsPage from './protected/dashboard-components/FormsPage';
import PaymentsPage from './protected/dashboard-components/PaymentsPage';
import ConsentPage from './protected/dashboard-components/ConsentPage';
import PrenatalClassesPage from './protected/dashboard-components/PrenatalClassesPage';
import NutritionGuidePage from './protected/dashboard-components/NutritionGuidePage';
import BirthPlanPage from './protected/dashboard-components/BirthPlanPage';

function App() {
  return (
    <AuthProvider>
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
      <Header />
      
      <Routes>
      
      <Route path="/" element={<Home />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/womens-health" element={<WomensHealth />} />
        <Route path="/care-packages" element={<CarePackages />} />
        <Route path="/services" element={<Services />} />
        <Route path="/preconception-care" element={<PreconceptionCare />} />
        <Route path="/antenatal-care" element={<AntenatalCare />} />
        <Route path="/labour-care" element={<LabourCare />} />
        <Route path="/postnatal-care" element={<PostnatalCare />} />
        <Route path="/adolescent-care" element={<AdolescentCare />} />
        <Route path="/child-care" element={<ChildCare />} />
        <Route path="/schedule-consultation" element={<ScheduleConsultation />} />
  <Route path="/contact" element={<ContactUs />} />
  <Route path="/about" element={<AboutUs />} />


<Route path="/AppointmentForm" element={<PrivateRoute><AppointmentForm /></PrivateRoute>} />
<Route path="/ChildVaccinationForm" element={<PrivateRoute><ChildVaccinationForm /></PrivateRoute>} />
<Route path="/LaborProgressForm" element={<PrivateRoute><LaborProgressForm /></PrivateRoute>} />
<Route path="/MedicalRecordForm" element={<PrivateRoute><MedicalRecordForm /></PrivateRoute>} />
<Route path="/PatientRegistration" element={<PrivateRoute><PatientRegistration /></PrivateRoute>} />
<Route path="/PostnatalVisitForm" element={<PrivateRoute><PostnatalVisitForm /></PrivateRoute>} />
<Route path="/PregnancyDetailsForm" element={<PrivateRoute><PregnancyDetailsForm /></PrivateRoute>} />
<Route path="/StaffRegistration" element={<PrivateRoute><StaffRegistration /></PrivateRoute>} />
<Route path="/Dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} /> 
<Route path="/messages" element={<PrivateRoute><MessagesPage /></PrivateRoute>} />
        <Route path="/forms" element={<PrivateRoute><FormsPage /></PrivateRoute>} />
        <Route path="/payments" element={<PrivateRoute><PaymentsPage /></PrivateRoute>} />
        <Route path="/consent" element={<PrivateRoute><ConsentPage /></PrivateRoute>} />
        <Route path="/prenatal-classes" element={<PrivateRoute><PrenatalClassesPage /></PrivateRoute>} />
        <Route path="/nutrition-guide" element={<PrivateRoute><NutritionGuidePage /></PrivateRoute>} />
        <Route path="/birth-plan" element={<PrivateRoute><BirthPlanPage /></PrivateRoute>} />

      </Routes>
      
      </main>
      <Footer />
    </div>
    </AuthProvider>
  );
}

export default App;